import Form from './Form'
export { withFieldSubmit } from './useSmartSubmit'

export default Form
